<template>
  <div class="new-process-step">
    <form @submit.prevent="submit_handler">
        <b-form-group horizontal label-class="text-sm-left" id="input-group-group" label="Group" label-for="input-group" description="">
            <b-form-select v-model="form.group" id="input-group-group">
              <option value="process_input">Process input</option>
              <option value="process_management">Process management</option>
              <option value="personnel_resources">Personnel resources</option>
              <option value="material_resources">Material resources</option>
              <option value="efficiency">Efficiency</option>
              <option value="process_output">Process output</option>
            </b-form-select>
        </b-form-group>

        <b-form-group horizontal label-class="text-sm-left" id="input-group-title" label="Title" label-for="input-title" description="">
            <b-form-input id="input-title" type="text" v-model="form.title" required placeholder="">
            </b-form-input>
        </b-form-group>
        <b-form-group horizontal label-class="text-sm-left" id="input-group-description" label="Risk description" label-for="input-description" description="">
            <b-form-textarea id="input-description" type="text" v-model="form.description" required placeholder="" :rows="4">
            </b-form-textarea>
        </b-form-group>
        <hr />
        <h5 v-if="form.questionnaires.length > 0">Questionnaires</h5>
        <div v-for="q in form.questionnaires">
          <b-card style="margin-bottom: 10px">
            {{ q.name }} {{ q.description }}
            <b-btn variant="danger" class="float-right" @click="remove_questionnaire(q)">Remove</b-btn>
          </b-card>
        </div>
        <b-form-group v-if="form.knowledge_item_id" horizontal label-class="text-sm-left" id="input-group-questionnaire" label="Questionnaire" label-for="input-questionnaire" description="">
          <b-input-group>
            <b-form-select id="input-description" v-model="form.questionnaire_id">
              <option :value="null">----</option>
              <optgroup v-for="g in questionnaires.questionnaire_groups" :label="g.name + ' ' + g.description">
                <option v-for="q in g.questionnaires" :value="q.questionnaire_id">{{ q.name }} {{ q.description }}</option>
              </optgroup>
            </b-form-select>
            <b-input-group-append>
              <b-btn @click="assign">Assign</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-button v-if="!hide_submit" type="submit" variant="primary">Add</b-button>
    </form>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: ['form', 'submit_handler', 'hide_submit', 'questionnaires'],
  created () {
      
  },
  watch: {
      
  },
  methods: {
    assign() {
      this.$http.post('v1/kb/1/items/' + this.form.knowledge_item_id + '/q', {
        'questionnaire_id': this.form.questionnaire_id
      }).then(response => {
        this.form.questionnaires = response.data.response;
      });
    },
    remove_questionnaire(questionnaire) {
      this.$http.delete('v1/kb/1/items/' + this.form.knowledge_item_id + '/q/' + questionnaire.questionnaire_id).then(response => {
        this.form.questionnaires = response.data.response;
      })
    }
  }
}
</script>